// Lista oficială a orașelor și municipiilor din România (ordonată alfabetic).
// Poți adăuga/edita aici dacă e nevoie.
const oraseRomania = [
  "Abrud", "Adjud", "Agnita", "Aiud", "Alba Iulia", "Aleșd", "Alexandria",
  "Amara", "Anina", "Aninoasa", "Arad", "Ardud", "Avrig", "Azuga",
  "Babadag", "Băbeni", "Bacău", "Baia de Aramă", "Baia de Arieș", "Baia Mare",
  "Baia Sprie", "Băicoi", "Băile Govora", "Băile Herculane", "Băile Olănești",
  "Băile Tușnad", "Băilești", "Balș", "Bălan", "Bălcești", "Baraolt", "Bârlad",
  "Bechet", "Beclean", "Beiuș", "Berbești", "Berești", "Bicaz", "Bistrița",
  "Blaj", "Bocșa", "Boldești-Scăeni", "Bolintin-Vale", "Borsec", "Borșa",
  "Botoșani", "Brad", "Bragadiru", "Brăila", "Brașov", "Breaza", "Brezoi",
  "Broșteni", "Bucecea", "București", "Budești", "Buftea", "Buhuși",
  "Bumbești-Jiu", "Bușteni", "Buzău", "Cajvana", "Calafat", "Călan", "Călărași",
  "Călimănești", "Câmpeni", "Câmpia Turzii", "Câmpina", "Câmpulung",
  "Câmpulung Moldovenesc", "Caracal", "Caransebeș", "Carei", "Cavnic",
  "Căzănești", "Cehu Silvaniei", "Cernavodă", "Chișineu-Criș", "Chitila",
  "Ciacova", "Cisnădie", "Cluj-Napoca", "Codlea", "Comănești", "Comarnic",
  "Constanța", "Copșa Mică", "Corabia", "Costești", "Covasna", "Craiova",
  "Cristuru Secuiesc", "Cugir", "Curtea de Argeș", "Curtici", "Dăbuleni",
  "Darabani", "Dărmănești", "Dej", "Deta", "Deva", "Dolhasca", "Dorohoi",
  "Drăgănești-Olt", "Drăgășani", "Dragomirești", "Drobeta-Turnu Severin",
  "Dumbrăveni", "Eforie", "Făget", "Făgăraș", "Fălticeni", "Făurei", "Fetești",
  "Fieni", "Fierbinți-Târg", "Filiași", "Flămânzi", "Focșani", "Frasin",
  "Fundulea", "Găești", "Galați", "Gătaia", "Geoagiu", "Gheorgheni", "Gherla",
  "Ghimbav", "Giurgiu", "Gura Humorului", "Hârlău", "Hârșova", "Haţeg",
  "Horezu", "Huedin", "Hunedoara", "Huși", "Ianca", "Iași", "Iernut", "Ineu",
  "Însurăței", "Întorsura Buzăului", "Isaccea", "Jibou", "Jimbolia",
  "Lehliu-Gară", "Lipova", "Liteni", "Livada", "Luduș", "Lupeni", "Măcin",
  "Măgurele", "Mangalia", "Marghita", "Mărășești", "Medgidia", "Mediaș",
  "Miercurea Ciuc", "Miercurea Nirajului", "Miercurea Sibiului", "Mihăilești",
  "Milișăuți", "Mioveni", "Mizil", "Moinești", "Moldova Nouă", "Moreni",
  "Motru", "Murfatlar", "Murgeni", "Nădlac", "Năsăud", "Năvodari", "Negrești",
  "Negrești-Oaș", "Negru Vodă", "Nehoiu", "Novaci", "Nucet", "Ocna Mureș",
  "Ocna Sibiului", "Ocnele Mari", "Odobești", "Odorheiu Secuiesc", "Oltenița",
  "Onești", "Oradea", "Oravița", "Orăștie", "Orșova", "Oțelu Roșu", "Otopeni",
  "Ovidiu", "Panciu", "Pâncota", "Pantelimon", "Pașcani", "Pătârlagele",
  "Pecica", "Petrila", "Petroșani", "Piatra-Neamț", "Piatra-Olt", "Pitești",
  "Ploiești", "Plopeni", "Podu Iloaiei", "Pogoanele", "Popești-Leordeni",
  "Predeal", "Pucioasa", "Răcari", "Rădăuți", "Râmnicu Sărat", "Râmnicu Vâlcea",
  "Râșnov", "Recaș", "Reghin", "Reșița", "Roman", "Roșiori de Vede", "Rovinari",
  "Roznov", "Rupea", "Săcele", "Săcueni", "Salcea", "Săliște", "Săliștea de Sus",
  "Salonta", "Sângeorgiu de Pădure", "Sângeorz-Băi", "Sânnicolau Mare",
  "Sântana", "Satu Mare", "Săveni", "Scornicești", "Sebeș", "Sebiș", "Segarcea",
  "Seini", "Sfântu Gheorghe", "Sibiu", "Sighetu Marmației", "Sighișoara",
  "Simeria", "Sinaia", "Slănic", "Slănic-Moldova", "Slatina", "Slobozia",
  "Solca", "Șomcuta Mare", "Sovata", "Ștefănești", "Ștei", "Strehaia",
  "Suceava", "Sulina", "Tălmaciu", "Țăndărei", "Târgoviște", "Târgu Bujor",
  "Târgu Cărbunești", "Târgu Frumos", "Târgu Jiu", "Târgu Lăpuș", "Târgu Mureș",
  "Târgu Neamț", "Târgu Ocna", "Târgu Secuiesc", "Târnăveni", "Tăuții-Măgherăuș",
  "Techirghiol", "Tecuci", "Teiuș", "Tismana", "Titu", "Toplița", "Topoloveni",
  "Tulcea", "Turceni", "Turda", "Turnu Măgurele", "Ulmeni", "Ungheni", "Uricani",
  "Urlați", "Urziceni", "Valea lui Mihai", "Vălenii de Munte", "Vânju Mare",
  "Vaslui", "Vatra Dornei", "Vicovu de Sus", "Victoria", "Videle",
  "Vișeu de Sus", "Vlăhița", "Voluntari", "Zalău", "Zărnești", "Zimnicea",
  "Zlatna",
];

export default oraseRomania;
